import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { TabDetection } from '@app/tab-detection/tab-detection-service/tab-detection';
import { TabDetectionWarning } from '@app/tab-detection/tab-detection-warning/tab-detection-warning';
import { EsignaturHeader } from '@shared/components/esignatur-header/esignatur-header';
import { EsignaturSnackbar } from '@shared/components/esignatur-snackbar/esignatur-snackbar';
import { clearAllLoadingAnimations } from '@app/providers/order-data/loading-animation-handler/loading-animation.handler';

@Component({
  selector: 'esignatur-root',
  imports: [TabDetectionWarning, EsignaturHeader, RouterOutlet, EsignaturSnackbar],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  readonly #tabService = inject(TabDetection, { optional: true });

  constructor() {
    inject(Router)
      .events.pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe(() => clearAllLoadingAnimations());
  }

  protected readonly showDuplicateWarning = computed(() => {
    if (!this.#tabService) return false;
    const isDuplicate = this.#tabService.isDuplicateTab();
    const mode = this.#tabService.config().mode;
    return isDuplicate && mode === 'block';
  });
}
